import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

const ConvertRecordingCursor = () => {
	const frame = useCurrentFrame();

	return (
		<MacOSCursor
			cursor={interpolate(
				frame,
				[4, 35, 91, 137, 185],
				['auto', 'pointer', 'auto', 'pointer', 'auto'],
				{
					easing: Easing.step1,
					extrapolateLeft: 'clamp',
					extrapolateRight: 'clamp',
				},
			)}
			style={{
				position: 'absolute',
				left: 0,
				top: 0,
				scale: interpolate(
					frame,
					[0, 65, 71, 175, 182, 685, 691],
					[
						3.4070240295748615, 3.0663216266173756, 3.4070240295748615,
						3.0663216266173756, 3.4070240295748615, 3.0663216266173756,
						3.4070240295748615,
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				),
				translate: interpolate(
					frame,
					[
						4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 26, 27, 28, 29, 30, 31,
						32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
						49, 50, 51, 52, 53, 90, 91, 92, 93, 94, 95, 112, 113, 114, 115, 116,
						117, 118, 119, 120, 121, 122, 129, 130, 131, 132, 133, 134, 135,
						136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148,
						149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161,
						184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196,
						197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209,
						210, 211, 212, 213, 214, 215, 216, 217, 218, 623, 624, 625, 626,
						627, 628, 629, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639,
						640, 641, 642, 643, 644, 645, 646, 647, 648, 649, 650, 651, 652,
						653, 654, 655, 656, 657, 658, 659, 660, 661, 662, 663, 664, 665,
						666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676, 677, 678,
						679,
					],
					[
						'23.84916820702403px 2295.375970425139px',
						'24.23512014787431px 2295.375970425139px',
						'28.786691312384473px 2290.811090573013px',
						'89.08835489833642px 2236.777818853974px',
						'241.37966728280963px 2110.145656192237px',
						'414.4591497227357px 1966.385212569316px',
						'658.5138632162661px 1763.0950092421442px',
						'802.0879852125694px 1615.9142329020333px',
						'922.10573012939px 1494.765249537893px',
						'961.5926062846581px 1461.2406654343808px',
						'966.1841035120149px 1458.3792975970425px',
						'966.6499075785582px 1458.139741219963px',
						'966.6499075785582px 1458.139741219963px',
						'966.6499075785582px 1457.7937153419593px',
						'966.9959334565619px 1455.1719038817007px',
						'969.47134935305px 1437.777449168207px',
						'969.5512014787431px 1425.6798521256933px',
						'969.5512014787431px 1414.9131238447321px',
						'969.3648798521257px 1398.82292051756px',
						'968.6062846580407px 1387.8166358595195px',
						'967.5548983364141px 1379.897966728281px',
						'967.1423290203328px 1374.1619223659889px',
						'966.6632162661738px 1367.9334565619224px',
						'966.4902033271719px 1362.3571164510167px',
						'966.31719038817px 1360.5870609981516px',
						'966.3038817005546px 1360.5338262476896px',
						'966.3038817005546px 1360.3741219963033px',
						'966.3038817005546px 1359.9615526802218px',
						'966.3038817005546px 1358.577449168207px',
						'966.3038817005546px 1356.0621072088725px',
						'966.3038817005546px 1356.0621072088725px',
						'966.3038817005546px 1346.8391866913125px',
						'966.3038817005546px 1339.6125693160814px',
						'966.7430683918669px 1330.456192236599px',
						'966.8229205175601px 1323.5489833641404px',
						'967.3286506469501px 1315.8166358595195px',
						'967.3286506469501px 1315.8166358595195px',
						'967.9541589648799px 1310.373382624769px',
						'968.0872458410352px 1309.5748613678375px',
						'968.1138632162662px 1309.5083179297599px',
						'968.1138632162662px 1309.5083179297599px',
						'1769.004066543438px 1759.5815157116451px',
						'1769.123844731978px 1759.6746765249538px',
						'1769.3634011090573px 1759.7146025878005px',
						'1771.120147874307px 1760.2203327171906px',
						'1772.2247689463957px 1760.765988909427px',
						'1772.2247689463957px 1760.765988909427px',
						'1771.905360443623px 1761.2850277264326px',
						'1767.6066543438078px 1768.9109057301296px',
						'1767.6066543438078px 1768.9109057301296px',
						'1757.8646950092423px 1790.018484288355px',
						'1756.4539741219965px 1794.3970425138632px',
						'1755.202957486137px 1797.138632162662px',
						'1753.8720887245843px 1798.815526802218px',
						'1752.2617375231055px 1801.1179297597043px',
						'1750.8243992606285px 1803.2340110905732px',
						'1750.1589648798522px 1804.0990757855823px',
						'1750.1589648798522px 1804.0990757855823px',
						'1750.0658040665435px 1804.1789279112754px',
						'1717.286506469501px 1826.1249537892793px',
						'1717.286506469501px 1826.1249537892793px',
						'1646.2314232902033px 1867.2354898336414px',
						'1500.2617375231055px 1944.5190388170056px',
						'1364.7260628465804px 2019.433641404806px',
						'1193.456561922366px 2117.8247689463956px',
						'1098.5789279112755px 2166.414787430684px',
						'995.569685767098px 2207.6983364140483px',
						'945.22292051756px 2226.184103512015px',
						'913.8410351201479px 2236.0591497227356px',
						'876.9892791127542px 2249.3678373382627px',
						'858.3970425138632px 2258.218114602588px',
						'842.7060998151571px 2266.895378927911px',
						'830.6750462107209px 2273.3634011090576px',
						'824.4731977818855px 2276.757116451017px',
						'818.9234750462108px 2279.2325323475047px',
						'815.4232902033272px 2280.230683918669px',
						'799.6524953789279px 2282.0539741219964px',
						'784.0547134935306px 2284.2765249537892px',
						'773.1948243992607px 2286.419223659889px',
						'766.660258780037px 2287.7367837338265px',
						'765.5024029574862px 2287.829944547135px',
						'765.5024029574862px 2287.829944547135px',
						'764.8236598890943px 2287.4839186691315px',
						'761.7626617375231px 2282.8391866913125px',
						'752.4998151571165px 2269.7035120147875px',
						'749.3456561922367px 2264.96561922366px',
						'747.3626617375231px 2261.279112754159px',
						'746.5375231053605px 2259.389279112754px',
						'746.071719038817px 2258.297966728281px',
						'745.8321626617376px 2257.9519408502774px',
						'745.8321626617376px 2257.9519408502774px',
						'748.2277264325323px 2256.022181146026px',
						'778.7046210720888px 2238.507948243993px',
						'807.5046210720888px 2222.9900184842886px',
						'947.8181146025878px 2161.969685767098px',
						'947.8181146025878px 2161.969685767098px',
						'1242.4724584103512px 2044.493900184843px',
						'1414.2343807763402px 1975.3818853974124px',
						'1552.0591497227358px 1922.7726432532347px',
						'1634.4266173752312px 1897.2199630314233px',
						'1722.8362292051756px 1875.127541589649px',
						'1753.6458410351202px 1866.9826247689464px',
						'1775.8846580406655px 1859.1571164510167px',
						'1786.558225508318px 1854.56561922366px',
						'1791.0964879852127px 1851.2251386321627px',
						'1797.9637707948245px 1845.4890942698707px',
						'1809.821811460259px 1836.3060998151573px',
						'1838.7682070240296px 1811.9645101663587px',
						'1874.2092421441776px 1785.3471349353051px',
						'1902.4768946395563px 1767.7530499075785px',
						'1931.1704251386323px 1751.3434380776341px',
						'1952.584103512015px 1741.335304990758px',
						'1972.9064695009242px 1734.5212569316081px',
						'1988.3445471349353px 1729.9563770794825px',
						'2000.4022181146026px 1727.441035120148px',
						'2015.7072088724585px 1724.060628465804px',
						'2036.5219963031425px 1719.9083179297597px',
						'2075.4232902033273px 1710.2462107208873px',
						'2109.520147874307px 1702.0214417744917px',
						'2133.6887245841035px 1696.0325323475047px',
						'2166.161922365989px 1689.1652495378928px',
						'2193.47134935305px 1684.6136783733828px',
						'2219.0240295748613px 1681.4462107208874px',
						'2223.3227356746766px 1680.9670979667283px',
						'2223.535674676525px 1680.9271719038818px',
						'2223.535674676525px 1680.9271719038818px',
						'2152.0014787430687px 1694.6351201478744px',
						'1987.8920517560075px 1722.7829944547136px',
						'1786.3719038817005px 1749.5866913123846px',
						'1692.9449168207025px 1761.2584103512015px',
						'1319.9290203327173px 1801.3974121996305px',
						'1148.1138632162663px 1828.4007393715342px',
						'1040.4332717190389px 1851.1585951940851px',
						'969.97707948244px 1869.8972273567467px',
						'938.9678373382625px 1882.1012939001848px',
						'879.5179297597043px 1907.4543438077635px',
						'819.309426987061px 1937.4121996303143px',
						'769.1223659889095px 1962.05988909427px',
						'724.0591497227357px 1978.2299445471351px',
						'665.9001848428836px 1995.331608133087px',
						'616.8842883548983px 2011.4218114602588px',
						'570.543438077634px 2030.825878003697px',
						'537.0587800369686px 2045.1593345656192px',
						'498.0243992606285px 2060.278003696858px',
						'457.4595194085028px 2075.130499075786px',
						'424.02809611829946px 2088.6121996303145px',
						'401.6561922365989px 2099.2325323475047px',
						'393.2051756007394px 2103.7308687615528px',
						'393.2051756007394px 2103.7308687615528px',
						'380.3489833641405px 2110.504990757856px',
						'344.70831792975974px 2131.226617375231px',
						'332.8236598890943px 2139.5445471349353px',
						'323.5475046210721px 2146.4517560073937px',
						'303.3449168207024px 2161.237707948244px',
						'276.581146025878px 2177.8203327171905px',
						'248.16709796672828px 2195.760443622921px',
						'235.84325323475048px 2204.4510166358596px',
						'222.62772643253237px 2211.2916820702403px',
						'205.69907578558227px 2218.8510166358597px',
						'185.7626617375231px 2227.608133086876px',
						'159.75748613678374px 2239.2133086876156px',
						'138.9826247689464px 2247.9571164510166px',
						'124.48946395563772px 2253.4536044362294px',
						'112.0724584103512px 2258.124953789279px',
						'103.95415896487985px 2260.999630314233px',
						'99.49574861367837px 2262.5833641404806px',
						'98.05841035120149px 2263.0358595194084px',
						'96.46136783733827px 2263.381885397412px',
						'96.30166358595194px 2263.4085027726433px',
						'96.27504621072089px 2263.4085027726433px',
						'94.54491682070241px 2263.6879852125694px',
						'84.80295748613679px 2266.0835489833644px',
						'70.61589648798521px 2270.7415896487987px',
						'70.61589648798521px 2270.7415896487987px',
						'58.03918669131239px 2275.7456561922368px',
						'53.78040665434381px 2277.542329020333px',
						'48.789648798521256px 2279.0462107208873px',
						'40.19223659889094px 2281.335304990758px',
						'36.78521256931608px 2282.5863216266175px',
						'36.692051756007395px 2282.5863216266175px',
						'36.385951940850276px 2282.5863216266175px',
						'36.27948243992606px 2282.5863216266175px',
					],
					{
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				),
			}}
		/>
	);
};

export const ExploreConvertRecording20261028Composition = () => {
	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={805}
			style={{
				width: 1332,
				height: 1440,
			}}
		>
			<Video
				src={
					'https://remotion.media/explore-remotion/convert-dark-source-2026-10-28-073fcd7b3366.mp4'
				}
				durationInFrames={805}
				style={{
					position: 'absolute',
				}}
			/>
			<ConvertRecordingCursor />
		</AbsoluteFill>
	);
};
